import { render, staticRenderFns } from "./FullScreenOverlayDesktop.vue?vue&type=template&id=24e6a058&scoped=true"
import script from "./FullScreenOverlayDesktop.vue?vue&type=script&lang=js"
export * from "./FullScreenOverlayDesktop.vue?vue&type=script&lang=js"
import style0 from "./FullScreenOverlayDesktop.vue?vue&type=style&index=0&id=24e6a058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e6a058",
  null
  
)

export default component.exports